export default __webpack_public_path__ + "static/media/ssl.d82e8ce8.png";